"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.phoneTenDigit = exports.ssn = exports.fein = exports.numericValueValidator = exports.maximumCharacters = exports.minimumCharacters = exports.numbersRequired = exports.lettersRequired = exports.validState = exports.emailMulti = exports.email = exports.required = void 0;

var _emailValidator = _interopRequireDefault(require("email-validator"));

var _lodash = require("lodash");

var _strings = require("../../constants/strings");

var _convertNumericString = require("../convertNumericString");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var required = function required(value, fieldName) {
  if ((0, _lodash.isNil)(value) || value.length === 0 || value === false) {
    return "".concat(fieldName, " ").concat(_strings.validationMessages.isRequired);
  }

  return '';
};

exports.required = required;

var email = function email(value) {
  if (!_emailValidator.default.validate(value)) {
    return _strings.validationMessages.validEmail;
  }

  return '';
};

exports.email = email;

var emailMulti = function emailMulti(value) {
  var cleaned = value // replace all whitespace that comes before a comma
  .replace(/(\s*)(?=,)/g, '') // replace all commas + whitespace that come before a word character with a comma
  .replace(/(,\s*)(?=(\w*))/g, ',') // replace a trailing comma if there is one
  .replace(/,$/, '');
  var emails = cleaned.split(',');

  if (emails.length <= 1) {
    return email(cleaned);
  }

  var errors = emails.reduce(function (acc, val) {
    if (!_emailValidator.default.validate(val)) {
      if (acc.length) {
        return "".concat(acc, ", ").concat(val);
      }

      return _strings.validationMessages.validMultiEmail + val;
    }

    return acc;
  }, '');
  return errors.length ? errors : '';
};

exports.emailMulti = emailMulti;

var validState = function validState(value) {
  if (!_strings.validUsStates.includes(value.toUpperCase())) {
    return _strings.validationMessages.coloradoAddress;
  }

  return '';
};

exports.validState = validState;

var lettersRequired = function lettersRequired(value) {
  var test = /^[a-zA-Z ]+$/;

  if (!test.test(value)) {
    return _strings.validationMessages.lettersRequired;
  }

  return '';
};

exports.lettersRequired = lettersRequired;

var numbersRequired = function numbersRequired(value) {
  var test = /^\d+$/;

  if (!test.test(value)) {
    return _strings.validationMessages.numbersRequired;
  }

  return '';
};

exports.numbersRequired = numbersRequired;

var minimumCharacters = function minimumCharacters(value, ruleValue) {
  if ((0, _lodash.isNil)(value) || value.length < ruleValue) {
    return "".concat(ruleValue, " ").concat(_strings.validationMessages.minCharacterCount);
  }

  return '';
};

exports.minimumCharacters = minimumCharacters;

var maximumCharacters = function maximumCharacters(value, ruleValue) {
  if (value.length > ruleValue) {
    return _strings.validationMessages.maxCharacterCount(ruleValue);
  }

  return '';
};

exports.maximumCharacters = maximumCharacters;

var numericValueValidator = function numericValueValidator(comparitor, value, ruleValue) {
  var numericValue = (0, _convertNumericString.convertNumericString)(value);
  var numericRuleValue = (0, _convertNumericString.convertNumericString)(ruleValue);

  if (Number.isNaN(numericValue) && value !== '' && value !== undefined || Number.isNaN(numericRuleValue)) {
    console.error('Value validation requires that the input value and be numeric values.'); // eslint-disable-line
  }

  switch (comparitor) {
    case 'min':
      {
        return numericValue < numericRuleValue ? "".concat(_strings.validationMessages.minimumValue(ruleValue)) : '';
      }

    case 'max':
      {
        return numericValue > numericRuleValue ? "".concat(_strings.validationMessages.maximumValue(ruleValue)) : '';
      }

    default:
      console.error('Ensure that ruleValidator includes the correct comparitor param.'); // eslint-disable-line

      return '';
  }
};

exports.numericValueValidator = numericValueValidator;

var fein = function fein(value) {
  if (!/^\d{2}-?\d{7}$/.test(value)) {
    return _strings.validationMessages.fein;
  }

  return '';
};

exports.fein = fein;

var ssn = function ssn(value) {
  if (!/^(?!0{3}|6{3})[0-8]\d{2}-(?!0{2})\d{2}-(?!0{4})\d{4}$/.test(value)) {
    return _strings.validationMessages.ssn;
  }

  return '';
};

exports.ssn = ssn;

var phoneTenDigit = function phoneTenDigit(value) {
  if (!/^\(\d{3}\)\s\d{3}-\d{4}$/.test(value)) {
    return _strings.validationMessages.phoneTenDigit;
  }

  return '';
};

exports.phoneTenDigit = phoneTenDigit;
var _default = {
  required: required,
  lettersRequired: lettersRequired,
  numbersRequired: numbersRequired
};
exports.default = _default;